export default function LoadingDots({ overlay = true }) {
  return (
    <>
      {overlay ? (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-[var(--phys-snow)]/80 backdrop-blur-[1px]">
          <DotsAnimation />
        </div>
      ) : (
        <div className="flex items-center justify-center py-20">
          <DotsAnimation />
        </div>
      )}
    </>
  );
}

function DotsAnimation() {
  return (
    <div className="flex items-center gap-3">
      <span
        className="w-2.5 h-2.5 rounded-full bg-[#333] animate-dot-pulse"
        style={{ animationDelay: '0ms' }}
      />
      <span
        className="w-2.5 h-2.5 rounded-full bg-[#333] animate-dot-pulse"
        style={{ animationDelay: '200ms' }}
      />
      <span
        className="w-2.5 h-2.5 rounded-full bg-[#333] animate-dot-pulse"
        style={{ animationDelay: '400ms' }}
      />
    </div>
  );
}
